// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:56:38

export default {
  "id": "drift-donut",
  "slug": "drift-donut",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f607d2f790ab400e95203e720e8061c1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f607d2f790ab400e95203e720e8061c1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Drift Donut",
      "description": "Drift into action with this exhilarating 3D car drifting game! Master the art of drifting as you take control of a variety of cars and navigate through uniquely designed donut-shaped roads. The challenge is simple: click or tap to start drifting and keep your car on the road to earn points. With every donut road you clear, your score increases, challenging you to push your drifting skills to the limit.",
      "instructions": "Drift your way through donut roads, earn points, unlock cars, and achieve greatness in this thrilling 3D drifting game!",
      "genres": [
        "Agility",
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "car",
        "drift",
        "endless",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "漂移甜甜圈",
      "description": "沉浸在令人兴奋的3D漂移赛车游戏中！掌握漂移艺术，操控各种车型，穿梭于独特设计的甜甜圈形道路上。挑战简单：点击或轻触开始漂移，保持车辆在道路上以获得分数。每通过一条甜甜圈道路，你的得分就会增加，挑战你将漂移技巧发挥到极致。",
      "instructions": "在甜甜圈道路上漂移前行，赚取积分，解锁车辆，在这款激动人心的3D漂移游戏中成就辉煌！",
      "genres": [
        "敏捷性",
        "竞速与驾驶"
      ],
      "tags": [
        "三维",
        "汽车",
        "漂移",
        "无尽",
        "技巧"
      ]
    },
    "zh-TW": {
      "title": "漂流甜甜圈",
      "description": "悠遊於這款令人興奮的3D駕駛漂移遊戲中！掌握駕駛漂移的藝術，操控各種車輛穿梭於獨特設計的甜甜圈形道路上。挑戰簡單：點擊或滑動開始漂移，並保持車輛在道路上以獲得分數。每通過一條甜甜圈道路，你的分數就會增加，挑戰你將駕駛漂移技巧發揮到極致。",
      "instructions": "穿梭於甜甜圈道路，獲得分數，解鎖車輛，並在這款刺激的3D滑行賽車遊戲中達成偉業！",
      "genres": [
        "敏捷性",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "車",
        "drifting",
        "無盡",
        "技巧"
      ]
    },
    "zh-HK": {
      "title": "漂流甜甜圈",
      "description": "隨著這款刺激的3D漂移車輛遊戲，投入行動的狂歡！掌握漂移藝術，控制各種車輛，穿過獨特設計的圓圈形道路。挑戰簡單：點擊或輕觸開始漂移，保持車輛在道路上以贏取分數。每通過一條圓圈道路，你的得分增加，挑戰你將漂移技巧發揮到極致。",
      "instructions": "穿梭於甜甜圈道路，積分滿載，解鎖愛車，在這場驚險的3D漂移遊戲中成就偉大！",
      "genres": [
        "敏捷度",
        "賽車及駕駛"
      ],
      "tags": [
        "3D",
        "車",
        "甩尾",
        "無限",
        "技巧"
      ]
    },
    "ja": {
      "title": "ドリフトドーナツ",
      "description": "この興奮満点の3Dカードリフトゲームでアクションに入り込もう！様々な車を操作しながら、ユニークにデザインされたドーナツ形の道路を駆け巡り、ドリフトの技術をマスターしよう。挑戦はシンプル：ドリフトを始めるためにクリックまたはタップし、車を道路上に保持してポイントを獲得しよう。ドーナツ形の道路を一つずつクリアするたびに、スコアが上がり、ドリフト技術を极限まで引き出すよう挑戦されます。",
      "instructions": "ドーナツロードを駆け抜け、ポイントを獲得し、車を解除し、このスリリングな3Dドリフトゲームで偉大なるものを目指せ！",
      "genres": [
        "アギリティ",
        "レーシング & ドライビング"
      ],
      "tags": [
        "3D",
        "車",
        "ドリフト",
        "無限",
        "スキル"
      ]
    },
    "ko": {
      "title": "드라이프 도넛",
      "description": "이 흥분되는 3D 드리프트 카트 게임으로 드리프트의 기술을 익혀보세요! 다양한 차량을 제어하여 독특하게 설계된 도나트 모양의 도로를 달리세요. 도전은 간단합니다: 드리프트를 시작하려면 클릭하거나 탭하세요. 그리고 점수를 얻기 위해 차량을 도로 위에 유지하세요. 도나트 도로를 모두 통과할수록 점수가 증가하며, 드리프트 기술을 최대한 발휘해보세요.",
      "instructions": "도넛 도로를 드리프트하며 점수를 획득하고, 차량을 해금하고, 이 흥미진진한 3D 드리프트 게임에서 위대함을 달성하세요!",
      "genres": [
        "기동력",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "자동차",
        "드리프트",
        "무한",
        "기술"
      ]
    },
    "fr": {
      "title": "Drift Donut",
      "description": "Glissez-vous dans l'action avec ce jeu de drift en 3D exhilarant ! Mastersez l'art du drift en prenant le contrôle d'une variété de voitures et en naviguant à travers des routes à donuts UNIQUEMENT conçues. Le défi est simple : cliquez ou touchez pour commencer à drift et gardez votre voiture sur la route pour gagner des points. À chaque route à donut que vous nettoyez, votre score augmente, vous défiant de pousser vos compétences en drift à leur maximum.",
      "instructions": "Glissez sur les routes de donuts, gagnez des points, débloquez des voitures et accomplissez des exploits dans ce thrilling jeu de drift 3D !",
      "genres": [
        "Agilité",
        "Courses & Conduite"
      ],
      "tags": [
        "3D",
        "voiture",
        "drift",
        "infini",
        "compétence"
      ]
    }
  }
};
